var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"turn-container"},[_c('span',[_vm._v("当前问题未解决，是否转人工")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.hasKefu}},[_vm._v("转人工")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }